export enum VisitStatusType {
  PENDING = 'PENDING',
  BOOKED = 'BOOKED',
  FULFILLED = 'FULFILLED',
  NO_SHOW = 'NO_SHOW',
  CANCELLED = 'CANCELLED',
  UNKNOWN = 'UNKNOWN',
}
